import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "qrcode",
  "use": "qrcode-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"qrcode\"><path stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M9.051 3.154H3.154V9.05H9.05zM9.051 14.949H3.154v5.897H9.05zM20.846 3.154H14.95V9.05h5.897z\" /><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.5\" d=\"M12 3.154V9.05M20.846 12H3.154M16.915 14.949v5.897M20.846 14.949v5.897M12.983 14.949v5.897\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol